export default {
  POLLING_INTERVAL_MS: 60 * 1000,
};
